import API from "@/services/api";
import {
  IAlert,
  IGetProductsResponse,
  IGetAlertsResponse,
  ISetAlertsResponse,
  IDeleteAlertsResponse
} from "../types/omip";

export enum EndpointVersion {
  V1 = "v1"
}

export enum EndpointName {
  Products = '/omip/products/',
  Alerts = '/omip/alerts/',
  DeleteAlert = '/omip/delete/alerts/',
}

const fetchProducts = () => {
  return API.get<IGetProductsResponse>({
    endpoint: EndpointName.Products,
  });
}

const fetchAlerts = () => {
  return API.get<IGetAlertsResponse>({
    endpoint: EndpointName.Alerts,
  });
}

const addAlert = ({
  id,
  product,
  type,
  price
}: IAlert) => {
  return API.post<ISetAlertsResponse, IAlert>({
    endpoint: EndpointName.Alerts,
    data: {
      id,
      product,
      type,
      price
    }
  })
}

const deleteAlert = (id: number) => {
  return API.post<IDeleteAlertsResponse, { id: number }>({
    endpoint: EndpointName.DeleteAlert,
    data: {id}
  })
}

export default {
  fetchProducts,
  fetchAlerts,
  addAlert,
  deleteAlert
};